<template>
  <div class="m-card-primary m-the-modal-content">
      <header class="m-the-modal-header">
        <h5 class="m-the-modal-header-title-error">
          {{ $t('mEditionBillingMyPaymentsChangePlanModalDisabled.title') }}
        </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p class="font-weight-bold margin-bottom-xlarge text-color-danger">
          {{ $t('mEditionBillingMyPaymentsChangePlanModalDisabled.messages') }}
        </p>
      </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsChangePlanModalDisabled'
}
</script>
